<template>
  <v-card flat class="v-card__container">
    <v-row class="d-flex align-center">
      <v-col>
        <h4 class="mb-0">Aktuella ärenden</h4>
      </v-col>
      
      <v-col class="d-flex align-center">
        <v-switch
          inset 
          v-model="myErrandsAreVisible"
          class="mb-0 ml-auto d-inline-block" 
          label="Hanterade ärenden"
          hide-details
          :disabled="isLoading"
          :loading="isLoading"
        ></v-switch>
      </v-col>
    </v-row>

    <Orders v-if="canSeeOrders" />

    <Applications />
    <StaleApplications />
    <InactiveBooks />
    <BasicEducationCertificates />
    <WidgetQualificationTime />
    <WidgetTradeCertificate />
    <MachinePermission />
    <InstructorExemption />
    <OtherCases />
    <template v-if="!handledCasesAreVisible">
      <CompaniesWithoutAgreement />
      <CompaniesAwaitingApproval />
      <CompaniesWithoutEmployees />
    </template>
  </v-card>
</template>

<script>
import Applications from '@/components/widgets/Applications'
import CompaniesWithoutEmployees from '@/components/widgets/CompaniesWithoutEmployees'
import BasicEducationCertificates from '@/components/widgets/BasicEducationCertificates'
import Orders from '@/components/widgets/Orders'
import WidgetTradeCertificate from '@/components/widgets/TradeCertificates'
import MachinePermission from '@/components/widgets/MachinePermission'
import InstructorExemption from '@/components/widgets/InstructorExemption'
import OtherCases from '@/components/widgets/OtherCases'
import WidgetQualificationTime from '@/components/widgets/WidgetQualificationTime'
import {mapGetters, mapActions} from 'vuex'
import {CanIDo} from '@/components/mixins'
import CompaniesWithoutAgreement from '@/components/widgets/CompaniesWithoutAgreement.vue'
import InactiveBooks from '@/components/widgets/InactiveBooks.vue'
import CompaniesAwaitingApproval from './widgets/CompaniesAwaitingApproval.vue'
import StaleApplications from './widgets/StaleApplications.vue'

// @group Common
// Welcome component
export default {
  name: 'Welcome',
  
  mixins: [CanIDo],

  components: {
    Applications,
    CompaniesWithoutEmployees,
    Orders,
    WidgetTradeCertificate,
    MachinePermission,
    InstructorExemption,
    BasicEducationCertificates,
    OtherCases,
    OtherCases,
    WidgetQualificationTime,
    CompaniesWithoutAgreement,
    InactiveBooks,
    CompaniesAwaitingApproval,
    StaleApplications
  },

  watch: {
    myErrandsAreVisible: {
      handler(value) {
        if ( value )
          this.setHandledCases(value)
      },
      immediate: true
    }
  },

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'handledCasesAreVisible']),
    ...mapGetters('app', ['isLoading']),

    myErrandsAreVisible: {
      get() {
        return localStorage.getItem('my-errands-view') || this.handledCasesAreVisible
      },
      set(value) {
        this.setHandledCases(value)
      }
    }
  },

  asyncComputed: {
    canSeeOrders(){
      return this.canIDo('admin', 'list');
    },
  },

  methods: {
    ...mapActions('currentuser', ['setHandledCases'])
  }
}
</script>

<style scoped>
</style>
